<template>
  <div class="forgot-password-container"
    :class="{ 'forgot-password-container-disabled': emailSent }">
    <div class="forgot-password-header">
      Reset Your Password
    </div>
    <div class="forgot-password-text">
      Please enter the email address associated with your account to reset your password.
    </div>
    <input class="forgot-password-input" placeholder="Email" name="email"
      v-model="email" type="text" @keypress.enter="submit"/>
    <div class="button-container" aria-label="Reset Password" @click="submit">
      Reset Password
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ForgotPassword',
  data() {
    return {
      email: '',
      emailSent: false,
    };
  },
  mounted() {
    if (this.authenticated) {
      this.$router.push('/');
    }
  },
  computed: {
    ...mapState('auth', ['backendAxios', 'authenticated']),
  },
  methods: {
    async submit() {
      const { email } = this;
      try {
        const passwordForgotResponse = await this.backendAxios.post('/auth/password/forgot', {
          email,
        });
        if (passwordForgotResponse) {
          this.emailSent = true;
          this.$toasted.show(passwordForgotResponse.data, {
            type: 'success',
            duration: 0,
          });
        }
      } catch (err) {
        this.$toasted.show(err.response.data, {
          type: 'info',
          duration: 0,
        });
      }
    },
  },
};

</script>

<style lang="scss" scoped>
@import '@/assets/youpaired-colors.scss';

input {
  padding: 0.75rem;
  margin-top:0.5rem;
  width: 15rem;
  border: 0.05rem solid #DCDBDB;
  border-radius: 0.1rem;
  -webkit-transition: border-color 0.15s;
  transition: border-color 0.15s;
  text-align: left;
  font-size: 0.875rem;
  font-weight: normal;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.forgot-password-container {
  padding-top: 5rem;
  width: 30rem;
  margin: 0 auto;
}

.forgot-password-header {
  font-size: 2rem;
}

.forgot-password-text {
  padding-top: 1rem;
  font-size: 1rem;
  text-align: left;
}

.forgot-password-input {
  padding-top: 1rem;
  width: 30rem;
}

.button-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 2.5rem;
  margin-top: 1rem;
  color: white;
  background-color: $login-background;
  font-size: 1rem;
  border-color: $login-background;
  font-weight: 700;
  cursor: pointer;
  border-radius: 0.3rem;
   &:hover {
    background-color: $login-hover;
    border-color: $login-hover;
  }
}

.forgot-password-container-disabled {
  filter: blur(0.15rem) grayscale(75%);
  -webkit-filter: blur(0.15rem) grayscale(75%);
  pointer-events: none;
}

</style>
